import type { IntlKey } from 'locales';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

interface CountLabelProps {
  count: number;
  labelId: IntlKey;
}

export const CountLabel: FC<CountLabelProps> = ({ count, labelId }) => {
  if (count === 0) {
    return null;
  }
  return (
    <span className="badge rounded-pill badge-outline-info fs-6 float-end ms-2" data-e2e="block-summary">
      <FormattedMessage id={labelId} values={{ count }} />
    </span>
  );
};
